import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthenticationService,ProfileService } from '../../_services/index';
import { CookieService } from "ngx-cookie-service";
import {Router} from "@angular/router"
@Component({
  selector: 'app-header-inner',
  templateUrl: './header-inner.component.html',
  styleUrls: ['./header-inner.component.scss']
})
export class HeaderInnerComponent {
  public profile:any;
  public notifications:any;
  private authorized:any;
  constructor(
    public as: AuthenticationService,
    private router: Router,
    public profileService: ProfileService,
    private cookieService: CookieService
  ){}
  ngOnInit() {
    this.authorized = this.as.checkAuthentication();
    if(!this.authorized.authorized){
        this.as.logout();
        this.router.navigate(['/login']);
    }else{
      this.profileService.cast.subscribe(response => {
          this.profile = response;
      }, error => {
      })
    }
  }
  url(path){
    this.router.navigate([path]);
  }
  verifyUrl(value) {
    var pattern = /^((http|https|ftp):\/\/)/;
    if (pattern.test(value)) {
      return value;
    } else {
    }
  }
  logout(){
    this.as.logout().subscribe(response => {
      this.cookieService.delete('incontrol');
      localStorage.removeItem('incontrol._access_token');
      this.router.navigate(['/login'])
    }, error => {
      this.cookieService.delete('incontrol');
      localStorage.removeItem('incontrol._access_token');
    })
  }
}

